export const formatNumber = (val?: number | string | null) => {
  if (!val) return 0;

  if (typeof val === 'string') {
    val = parseFloat(val);
  }

  return val.toLocaleString('en-US');
};
